import MathManager from '@/utils/math-manager.utils'

import ACQUIRER_LABELS from '../Acquirer/acquirer.labels'

class RefusalCodes {
  dashProgressManager
  data

  constructor (data, dashProgressManager) {
    this.data = data
    this.dashProgressManager = dashProgressManager
  }

  static totalQuantity (list) {
    return MathManager.sumByKeys(list).quantity
  }

  defaultStructure = Object.keys(ACQUIRER_LABELS)

  /**
   * parseLabel takes in a single parameter label and returns a string value by matching the label parameter
   * with the key of an object validationLabel.
   * @param {String} label the label to convert
   * @returns String
   */
  parseLabel (label) {
    const validationLabel = {
      ...ACQUIRER_LABELS
    }
    return validationLabel[label]
  }

  adapter (defaultStructure, totalAcquirer) {
    const newList = this.data.map((acquirer, index) => {
      const item = { ...defaultStructure[acquirer.name], ...acquirer }

      const totalCodes = MathManager.sumByKeys(
        acquirer.buckets.return_code
      ).quantity

      const others = this.dashProgressManager.adapterTooltipRemaining(
        acquirer.buckets.return_code,
        totalCodes
      )

      return {
        ...item,
        key: item.name,
        name: this.parseLabel(item.name) ?? item.name,
        color: this.dashProgressManager.getColor(index),
        value: this.dashProgressManager.getCurrency(item.tpv),

        // We do this to make sure that we are doing the percentage based on each accquirer
        percentage: MathManager.percentageCalculator(
          item.quantity,
          totalAcquirer
        ),
        rightIcon: {
          name: 'tooltip',
          tooltip: others
        }
      }
    })

    return newList
  }

  /**
   * Executes all the methods
   * @returns Array
   */
  get () {
    const defaultStructure = this.dashProgressManager.createStructure(
      this.defaultStructure
    )

    const totalAcquirer = MathManager.sumByKeys(this.data).quantity

    return this.adapter(defaultStructure, totalAcquirer)
  }
}

export default RefusalCodes
